module.exports = __webpack_public_path__ + "static/media/plus-coinera.e714c6c5.svg";